import useBootstrapData from '@/hooks/useBootstrapData'
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'
import { type IArticleType, type ICollectionType, ContentfulRichText } from '@pcln/contentful-components'
import { Box, Text } from 'pcln-design-system'
import { Fragment } from 'react'
import type { FAQPage, WithContext } from 'schema-dts'
import styled from 'styled-components'
import SchemaMarkup from '../SchemaMarkup/SchemaMarkup'

const ContentfulRichTextStyled = styled(ContentfulRichText)`
  line-height: 1.5;
`

const FAQContainer = styled(Box)`
  ${({ isMobile }: { isMobile: boolean }) => !isMobile && 'column-count: 2;'}
  > p {
    margin-bottom: 16px;
    margin-top: 8px;
    font-size: 12px;
  }
  margin: 25px;
`
export default function FAQ({ articles }: { articles: ICollectionType<IArticleType> }) {
  const { isMobile } = useBootstrapData()

  const faqItems = articles.items.filter((item) => !item.internalName?.includes('faq_description'))

  const headline = articles.headline
  const description = articles.items.find((item) => item.internalName?.includes('faq_description'))

  const faqQuestions = faqItems.map((question, index) => {
    return (
      <Fragment key={`faq-question-${index}`}>
        <Text bold>{question.headline}</Text>
        {question.body ? <ContentfulRichTextStyled body={question.body} fontSize={0} /> : null}
      </Fragment>
    )
  })

  const FAQSchemaMarkup: WithContext<FAQPage> = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      ...faqItems.map(
        (question) =>
          ({
            '@type': 'Question',
            name: question.headline,
            acceptedAnswer: {
              '@type': 'Answer',
              text: question.body ? documentToPlainTextString(question.body) : '',
            },
          }) as const,
      ),
    ],
  } as const

  if (faqQuestions.length === 0) {
    return null
  }

  return (
    <>
      <SchemaMarkup schema={FAQSchemaMarkup} />
      <FAQContainer isMobile={isMobile}>
        <Text bold fontSize={4} mb={2}>
          {headline}
        </Text>
        {description?.body ? <ContentfulRichTextStyled body={description.body} /> : null}
        {faqQuestions}
      </FAQContainer>
    </>
  )
}
